module.exports = __webpack_public_path__ + "ff44612959e145de53feee84b4403a7e.png";